import { createRouter, createWebHistory } from 'vue-router';

import useAuthStore from '@/store/auth';
const { isLogin, authInfo, logout, isAuthenticated } = useAuthStore();

const routes = [
  {
    path: '/',
    name: 'MainHome',
    component: () =>
      import(/* webpackChunkName: "main" */ '@/feature/main/views/MainHome.vue')
  },
  /* 로그인 */
  {
    path: '/login',
    name: 'UserLogin',
    component: () =>
      import(
        /* webpackChunkName: "login" */ '@/feature/login/views/UserLogin.vue'
      ),
    meta: {
      noAuth: true
    }
  },
  /* 회원가입 */
  {
    path: '/join/:type',
    name: 'JoinView',
    component: () =>
      import(
        /* webpackChunkName: "join" */ '@/feature/join/views/JoinView.vue'
      ),
    meta: {
      noAuth: true
    }
  },
  /* 마이페이지 */
  {
    path: '/mypage',
    name: 'MyPage',
    component: () =>
      import(
        /* webpackChunkName: "mypage" */ '@/feature/mypage/views/MyPage.vue'
      )
  },
  /* ow 알림창 기금신청 시작 */
  /* 서류안내 */
  {
    path: '/funding/:type',
    name: 'NewFunding',
    component: () =>
      import(
        /* webpackChunkName: "funding" */ '@/feature/funding/views/NewFunding.vue'
      )
  },
  /* 출자관리 */
  {
    path: '/fund',
    name: 'FundManage',
    component: () =>
      import(
        /* webpackChunkName: "fund" */ '@/feature/fund/views/FundManage.vue'
      )
  },
  /* 자료실 */
  {
    path: '/board',
    name: 'LibraryPage',
    component: () =>
      import(
        /* webpackChunkName: "event" */ '@/feature/library/views/LibraryPage.vue'
      )
  },
  // 자료실 상세
  {
    path: '/board/:id',
    name: 'LibraryDetail',
    component: () =>
      import(
        /* webpackChunkName: "event" */ '@/feature/library/views/LibraryDetail.vue'
      )
  },
  /* 문의하기 */
  {
    path: '/inquiry/:type',
    name: 'InquiryPage',
    component: () =>
      import(
        /* webpackChunkName: "qna" */ '@/feature/inquiry/views/InquiryPage.vue'
      ),
    props: true
  },
  /* 공지사항 */
  {
    path: '/notice',
    name: 'NoticePage',
    component: () =>
      import(
        /* webpackChunkName: "notice" */ '@/feature/notice/views/NoticePage.vue'
      )
  },
  /* 공지사항상세*/
  {
    path: '/notice/:id',
    name: 'NoticeDetail',
    component: () =>
      import(
        /* webpackChunkName: "notice" */ '@/feature/notice/views/NoticeDetail.vue'
      )
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // 부드럽게 최상단으로 스크롤 이동
    return { top: 0, behavior: 'smooth' };
  }
});

router.beforeEach((to, from, next) => {
  if (!to.meta.noAuth && !isAuthenticated.value()) {
    return next('/login');
  }

  next();
});

export default router;
